import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TextListObject} from '@PosterWhiteboard/items/text-item/text-list';

export function useGetKeyFromListOfActiveItem<T extends keyof TextListObject>(key: T): TextListObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'list' in item && item.list[key] !== undefined) {
      return item.list[key];
    }

    return undefined;
  });
}
